export interface IIngredient {
    id: number;
    name: string;
    price: number;
  }
  
  export const INGREDIENTS = [
    {
      id: 1,
      name: "Mozarella",
      price: 3.00
    },
    {
      id: 2,
      name: "Viande hachée",
      price: 4.00
    },
    {
      id: 3,
      name: "Champignons",
      price: 2.00
    },
    {
      id: 4,
      name: "Poulet fumé",
      price: 3.50
    },
    {
      id: 5,
      name: "Chèvre",
      price: 2.00
    },
    {
      id: 6,
      name: "Boursin",
      price: 2.00
    },
    {
      id: 7,
      name: "Gorgonzola",
      price: 2.50
    },
    {
      id: 8,
      name: "Escalope",
      price: 3.00
    },
    {
      id: 9,
      name: "Kebab",
      price: 3.50
    },
    {
      id: 10,
      name: "Cordon Bleu",
      price: 3.00
    },
    {
      id: 11,
      name: "Merguez",
      price: 2.50
    },
    {
      id: 12,
      name: "Chorizo",
      price: 2.50
    },
    {
      id: 13,
      name: "Jambon",
      price: 2.50
    },
    {
      id: 14,
      name: "Lardons",
      price: 1.50
    },
    {
      id: 15,
      name: "Saumon",
      price: 4.00
    }
  ]